// 날짜 보기 좋은 형식으로 변경하는 함수
export function convertDatetimeToString(
  date: string | Date,
  isFullYear: boolean = false,
  hasTime: boolean = true,
): string {
  const inputDate = new Date(date);

  return (
    (isFullYear
      ? inputDate.getFullYear().toString()
      : inputDate.getFullYear().toString().slice(2)) +
    '.' +
    (inputDate.getMonth() + 1).toString().padStart(2, '0') +
    '.' +
    inputDate.getDate().toString().padStart(2, '0') +
    ' ' +
    (hasTime
      ? inputDate.getHours().toString().padStart(2, '0') +
        ':' +
        inputDate.getMinutes().toString().padStart(2, '0')
      : '')
  );
}

export function objectIdToDate(objectId: string): Date {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
}

export function convertMonthAndDayToString(dateString: string): string {
  const inputDate = new Date(dateString);
  return (
    (inputDate.getMonth() + 1).toString().padStart(2, '0') +
    '.' +
    inputDate.getDate().toString().padStart(2, '0')
  );
}

export function convertTimeToString(dateString: string): string {
  const inputDate = new Date(dateString);
  return (
    inputDate.getHours().toString().padStart(2, '0') +
    ':' +
    inputDate.getMinutes().toString().padStart(2, '0')
  );
}

export function isToday(dateString: string) {
  const inputDate = new Date(dateString);
  const today = new Date();

  return (
    inputDate.getUTCFullYear() === today.getUTCFullYear() &&
    inputDate.getUTCMonth() === today.getUTCMonth() &&
    inputDate.getUTCDate() === today.getUTCDate()
  );
}
